import { omuniWeb } from "./conf";

/**
 * Manda al acceso, que ahora vive en omuni-web.
 *
 * Con una navegación de página entera y no con `history.push`: el login es
 * otra aplicación, así que el router de esta no puede llegar --empujaría una
 * ruta que acá no existe y dejaría la pantalla en blanco--.
 *
 * `replace` y no `href` para que el "atrás" del navegador no devuelva a la
 * pantalla de la que se acaba de expulsar a alguien sin sesión.
 */
export const goToLogin = () => {
  window.location.replace(`${omuniWeb}/login`);
};
